/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type MondayBatchJobStateJobType =
  (typeof MondayBatchJobStateJobType)[keyof typeof MondayBatchJobStateJobType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MondayBatchJobStateJobType = {
  MONDAY: "MONDAY",
  WRITING: "WRITING",
} as const;
